import { render, staticRenderFns } from "./DownTime.vue?vue&type=template&id=1a7dffc1&scoped=true"
import script from "./DownTime.vue?vue&type=script&lang=js"
export * from "./DownTime.vue?vue&type=script&lang=js"
import style0 from "./DownTime.vue?vue&type=style&index=0&id=1a7dffc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7dffc1",
  null
  
)

export default component.exports